// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-component{border:20px;padding:0}.modal-component-header{border-bottom:1px solid #d4d4d4}
`, "",{"version":3,"sources":["webpack://./src/app/components/Modal/styles.scss"],"names":[],"mappings":"AAAA,iBACE,WAAY,CACZ,SAAU,CAEV,wBACE,+BAAgC","sourcesContent":[".modal-component {\n  border: 20px;\n  padding: 0;\n\n  &-header {\n    border-bottom: 1px solid #d4d4d4;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
